<nz-card>
    <ng-container *ngIf="currentCustomer else loading">
        <div nz-row nzJustify="space-between" >
            <div nz-col nzSpan="8" style="padding: 8px;" >
                <div nz-col nzJustify="space-between">
                    <span nz-row nzJustify="space-between" style="font-size: larger; font-weight:500">
                        <span>
                            <span nz-icon nzType="user" nzTheme="outline" style="margin-right: 8px;"></span>
                            <span>{{ currentCustomer.customer.name }} <span nz-icon nzType="star" nzTheme="fill" *ngIf="this.isThisSalesMan" nz-tooltip="You are favourite salesman"></span></span>
                        </span>
                        <button nz-button nzType="primary" nzSize="default" (click)="openCustomer()">
                            <span nz-icon nzType="edit" nzTheme="outline" nz-tooltip="Edit Customer"></span>
                        </button>
                    </span>
                    <span style="font-style: italic; cursor: pointer; font-size: small;" *ngIf="currentCustomer.parentCustomer" (click)="navigateToCustomer(currentCustomer.parentCustomer.customerId)" > 
                                (Main Debtor: {{currentCustomer.parentCustomer.name}}) 
                                    <span nz-icon nzType="sf:openInNew" nzTheme="outline"></span>                       
                    </span>            
                </div>

                <nz-collapse *ngIf="hasSubCustomers" nzGhost>
                    <nz-collapse-panel nzHeader="Linked Customers" [nzActive]="false">
                            <nz-tree-view [nzTreeControl]="treeControl" [nzDataSource]="subCustomerDataSource">
                                <nz-tree-node *nzTreeNodeDef="let node" nzTreeNodePadding>
                                    <nz-tree-node-toggle nzTreeNodeNoopToggle></nz-tree-node-toggle>
                                    <nz-tree-node-option
                                        [nzDisabled]="node.disabled"
                                        [nzSelected]="selectListSelection.isSelected(node)"
                                        (nzClick)="selectListSelection.toggle(node)"
                                    >
                                        <span >{{ node.name }}</span>
                                        <span *ngIf="node.email" style="font-size: 12px; color: gray; margin-left: 10px;" >{{ node.email }}</span>
                                        <span *ngIf="node.cell" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.cell }}</span>
                                       
                                    </nz-tree-node-option>
                                    <span (click)="navigateToCustomer(node.customerId)" nz-icon nzType="sf:openInNew" nzTheme="outline" style="cursor: pointer;"></span>
                                    </nz-tree-node>
                            
                                    <nz-tree-node *nzTreeNodeDef="let node; when: hasChild" nzTreeNodePadding>
                                    <nz-tree-node-toggle>
                                        <span nz-icon nzType="caret-down" nzTreeNodeToggleRotateIcon></span>
                                    </nz-tree-node-toggle>
                                    <nz-tree-node-option
                                        [nzDisabled]="node.disabled"
                                        [nzSelected]="selectListSelection.isSelected(node)"
                                        (nzClick)="selectListSelection.toggle(node)"
                                        >
                                        <span>{{ node.name }}</span>
                                        <span *ngIf="node.email" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.email }}</span>
                                        <span *ngIf="node.cell" style="font-size: 12px; color: gray; margin-left: 10px;">{{ node.cell }}</span>
                                    </nz-tree-node-option>
                                    <span (click)="navigateToCustomer(node.customerId)" nz-icon nzType="sf:openInNew" nzTheme="outline" style="cursor: pointer;"></span>
                                </nz-tree-node>
                            </nz-tree-view>
                    </nz-collapse-panel>
                </nz-collapse>
   
  
               


            </div>
            <div nz-col nzSpan="8" style="padding: 8px; ">
                    <app-searchbar></app-searchbar>
                <div>
 
                </div>
            </div>
            <div nz-col nzSpan="8" style="padding: 8px; text-align: right;">
                <div nz-col style="text-align: right;">
                    <div *ngIf="currentCustomer.customer.cell"><span nz-icon nzType="phone" nzTheme="outline"></span> {{ currentCustomer.customer.cell }}</div>
                    <div *ngIf="currentCustomer.customer.email"><span nz-icon nzType="mail" nzTheme="outline"></span> {{ currentCustomer.customer.email }}</div>
                    <div *ngIf="currentCustomer.customer.VATNumber"><span nz-icon nzType="dollar-circle" nzTheme="outline" style="margin-right: 4px;"></span>VAT: {{ currentCustomer.customer.VATNumber }}</div>
                </div>
                <div style="text-align: right;">
                    <button nz-button nzType="default" nzSize="small" *ngFor="let item of currentCustomer.communities" style="margin-top: 5px; margin-left: 5px;" [nz-tooltip]="item.groupDescription">
                        <span nz-icon nzType="check-circle" nzTheme="outline" class="color-success" style="text-align: end;"></span> {{item.groupName}}
                    </button>
                </div>
            </div>
    </div>
    <div nz-row nzJustify="space-between" style="padding: 8px;" nzGutter="32">
            <div nz-col nzSpan="8" style="text-align: right; border-right: 1px solid #eee;">
                <div nz-col style="width: 100%">
                    <div [ngStyle]="{
                                'padding': '8px',
                                'border-radius': '8px',
                                'border': '2px solid ' + quoteVsSaleColor,
                                'font-weight': '500',
                                'margin-top': '8px',
                            }" [nz-tooltip]="salesratioTooltip" [nzTooltipPlacement]="'topRight'"> <ng-template #salesratioTooltip>
                                <span nz-icon nzType="info-circle" nzTheme="outline" [ngStyle]="{'margin-right': '4px', 'color': quoteVsSaleColor}"></span>Conversion ratio: {{ quoteVsSale }}%
                            </ng-template>
                            
                        <div nz-row nzJustify="space-between" *ngIf="currentCustomer.quotes">
                            <div><span nz-icon nzType="dollar" nzTheme="outline" style="margin-right: 4px;"></span>Total Quotes:</div> {{currentCustomer.quotes.length}}<br>
                        </div>
                        <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.sales">
                        <div> <span nz-icon nzType="shopping-cart" nzTheme="outline" style="margin-right: 4px;"></span>Total Sales:</div> {{ currentCustomer.totalSales }}<br>
                        </div>
                    </div>
                </div>

                <div nz-col style="width: 100%">
                <div nz-row style="margin-top: 8px;" *ngIf="currentCustomer.ltv ">
                    <div style="width: 100%;" nz-col>
                        <div [nz-tooltip]="totalSpendTooltip" [nzTooltipPlacement]="'topRight'" [ngStyle]="{
                                'padding': '8px',
                                'border-radius': '8px',
                                'border': '2px solid ' + totalSpendColor,
                                'font-weight': '500',
                            }">
                            <ng-template #totalSpendTooltip>
                                <span nz-icon nzType="info-circle" nzTheme="outline" [ngStyle]="{'margin-right': '4px', 'color': totalSpendColor}"></span>Total Spend {{ totalSpendInterval }}
                            </ng-template>
                        <div nz-row nzJustify="space-between" >
                            <div style="font-weight: 500;"><span nz-icon nzType="dollar-circle" nzTheme="outline" style="margin-right: 4px;"></span>Total Spend:</div><div>{{ currentCustomer.ltv | currency: 'R':'symbol' }}</div>
                        </div>
                        </div>
                        <div [nz-tooltip]="avgSpendTooltip" [nzTooltipPlacement]="'topRight'" [ngStyle]="{
                                'padding': '8px',
                                'border-radius': '8px',
                                'border': '2px solid ' + avgSpendColor,
                                'font-weight': '500',
                                'margin-top': '8px',
                            }">
                            <ng-template #avgSpendTooltip>
                                <span nz-icon nzType="info-circle" nzTheme="outline" [ngStyle]="{'margin-right': '4px', 'color': avgSpendColor}"></span>Average Spend {{ avgSpendInterval }}
                            </ng-template>
                        <div nz-row nzJustify="space-between" >
                            <div style="font-weight: 500;"><span nz-icon nzType="dollar-circle" nzTheme="outline" style="margin-right: 4px;"></span>Average Spend:</div><div>{{ currentCustomer.averageSpend | currency: 'R':'symbol' }}</div>
                        </div>
                        </div>
                    </div>
                </div>
                </div>
            </div>
        <div nz-col nzSpan="8" style="text-align: right; border-right: 1px solid #eee;">
                <div *ngIf="currentCustomer.firstPurchase" [ngStyle]="{
                                    'padding': '8px',
                                    'border-radius': '8px',
                                    'border': '2px solid  ' + firstAndLastPurchaseDateColor,
                                    'font-weight': '500',
                                    'margin-top': '8px',
                                }" [nz-tooltip]="customerTooltip" [nzTooltipPlacement]="'topRight'">
                    <ng-template #customerTooltip>
                                <span nz-icon nzType="info-circle" nzTheme="outline" [ngStyle]="{'margin-right': '4px', 'color': firstAndLastPurchaseDateColor}"></span>Been a customer for {{ customerLifeTime }}
                            </ng-template>
              <div nz-row nzJustify="space-between"  *ngIf="currentCustomer.firstPurchase">
                        <span style="font-weight: 500;">First Purchase:</span>
                        <span >{{ currentCustomer.firstPurchase | date: 'dd MMM, yyyy' }}</span>
                    </div>
                    <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.lastPurchase ">
                    <div style="font-weight: 500;">Last Purchase:</div><div>{{ currentCustomer.lastPurchase | date: 'dd MMM, yyyy' }}</div>
                    </div>
                </div>
            <div nz-row *ngIf="currentCustomer.openQuotes>0" nzJustify="space-between"
                style="margin-top: 24px;
                    align-items: center;
                    border-radius: 8px;">
                <div style="display: flex; align-items: center;">
                    <span nz-icon nzType="dollar" nzTheme="outline"
                        style="font-size: 2rem;
                            border-radius: 50%;
                            padding: 8px;"></span>
                    <span style="font-size: 1.15rem; font-weight: 500;">
                        Open Quotes
                    </span>
                </div>
                <button nz-button nzType="primary" nzSize="large" (click)="goToOpenQuotes()"
                    style="font-size: 1.5rem;
                        font-weight: 700;
                        min-width: 32px;
                        height: 32px;
                        display: flex;
                        align-items: center;
                        justify-content: center;">
                    {{ currentCustomer.openQuotes }}
                </button>
            </div>
        </div>
        <div nz-col nzSpan="8" style="text-align: right;" 
        >
            <div [ngStyle]="{
                                        'padding': '8px',
                                        'border-radius': '8px',
                                        'border': '2px solid  ' + tierColor,
                                        'font-weight': '500',
                                        'margin-top': '8px',
                                    }" [nz-tooltip]="tierTooltip" [nzTooltipPlacement]="'topRight'">
                <ng-template #tierTooltip>
                    <span nz-icon nzType="info-circle" nzTheme="outline" [ngStyle]="{'margin-right': '4px', 'color': tierColor}"></span>Customer Tier: {{ favouriteTyreBrandTier }}
                </ng-template>
                <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.mostFrequentTyreBrandsBought && currentCustomer.mostFrequentTyreBrandsBought.length > 0">
                    <span  style="font-weight: 500;">Popular Brands:</span>
                    <div *ngFor="let brand of currentCustomer.mostFrequentTyreBrandsBought">
                        <img src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{brand}}" class="brandImage" alt="{{brand}}"  />
                    </div>
                </div>
                <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.mostFrequentSizesBought && currentCustomer.mostFrequentSizesBought.length > 0">
                    <span  style="font-weight: 500;">Popular Size:</span>
                    <div >
                        <button nz-button nzSize="small" *ngFor="let size of currentCustomer.mostFrequentSizesBought" >{{ size }}</button>
                    </div>

                </div>
                <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.mostRecentVehicle">
                    <span style="font-weight: 500;">Most Recent Vehicle:</span>
                    <span>{{ currentCustomer.mostRecentVehicle }}</span>
                </div>
                            <div nz-row nzJustify="space-between" style="margin-top: 8px;" *ngIf="currentCustomer.mostRecentSalesman">
                    <span style="font-weight: 500;">Popular Salesman:</span>
                    
                    <span><span nz-icon nzType="star" nzTheme="fill" *ngIf="this.isThisSalesMan"></span>{{ currentCustomer.mostRecentSalesman }}</span>
                </div>
            </div>
        </div>
    </div>
    <nz-collapse nzGhost style="margin-bottom: 8px;">
        <nz-collapse-panel 
            [nzHeader]="
                'Vehicle Maintenance Alerts (' + maintenanceAlerts + ')'
            " 
            [nzActive]="maintenanceAlerts > 0 ? true : false"
            [ngClass]="maintenanceAlerts > 0 ? 'maintenance-alert-header' : ''"
        >
            <div nz-row nzGutter="16">
                <div nz-col [nzSpan]="8">
                    <nz-card
  nzBordered="false"
  [ngClass]="dueForAlignment.length ? 'maintenance-card-yellow' : 'maintenance-card-blue'"
  [ngStyle]="{ 'margin-bottom': '0'}">
                        <div style="display: flex; align-items: center; margin-bottom: 8px;">
                            <span nz-icon nzType="compass" nzTheme="outline" style="color: #faad14; font-size: 20px; margin-right: 8px;"></span>
                            <span style="font-weight: 600;">Wheel Alignment Due</span>
                        </div>
                        <ng-container *ngIf="dueForAlignment.length; else noAlignment">
                            <div *ngFor="let vehicle of dueForAlignment" style="margin-bottom: 6px;" nz-row  nzJustify="space-between">
                                <span nz-col nzSpan="8" style="font-weight: 500;">{{vehicle.make}} {{vehicle.model}} {{ vehicle.vreg }}:</span>
                                <span nz-col nzSpan="8" >Last: {{ vehicle.lastAlignmentDt | date : 'dd MMM, yyyy' }}</span>
                                <span  nz-col nzSpan="4" style="color: #cf1322; font-weight: bold;"> (Overdue)</span>
                            </div>
                        </ng-container>
                        <ng-template #noAlignment>
                            <span style="color: #b7b7b7;">No vehicles due</span>
                        </ng-template>
                    </nz-card>
                </div>
                <div nz-col [nzSpan]="8">
                    <nz-card
  nzBordered="false"
  [ngClass]="dueForBalance.length ? 'maintenance-card-yellow' : 'maintenance-card-blue'"
  [ngStyle]="{ 'margin-bottom': '0'}">
                        <div style="display: flex; align-items: center; margin-bottom: 8px;">
                            <span nz-icon nzType="deployment-unit" nzTheme="outline" style="color: #faad14; font-size: 20px; margin-right: 8px;"></span>
                            <span style="font-weight: 600;">Wheel Balancing Due</span>
                        </div>
                        <ng-container *ngIf="dueForBalance.length; else noBalance">
                            <div *ngFor="let vehicle of dueForBalance" style="margin-bottom: 6px;" nz-row nzJustify="space-between">
                                <span nz-col nzSpan="8" style="font-weight: 500;">{{vehicle.make}} {{vehicle.model}} {{ vehicle.vreg }}:</span>
                                <span nz-col nzSpan="8" >Last: {{ vehicle.lastBalancingDt | date : 'dd MMM, yyyy' }}</span>
                                <span nz-col nzSpan="4" style="color: #cf1322; font-weight: bold;"> (Overdue)</span>
                            </div>
                        </ng-container>
                        <ng-template #noBalance>
                            <span style="color: #b7b7b7;">No vehicles due</span>
                        </ng-template>
                    </nz-card>
                </div>
                <div nz-col [nzSpan]="8">
                   <nz-card
  nzBordered="false"
  [ngClass]="dueForTyreChange.length ? 'maintenance-card-yellow' : 'maintenance-card-blue'"
  [ngStyle]="{ 'margin-bottom': '0'}">     <div style="display: flex; align-items: center; margin-bottom: 8px;">
                            <span nz-icon nzType="car" nzTheme="outline" style="color: #faad14; font-size: 20px; margin-right: 8px;"></span>
                            <span style="font-weight: 600;">Tyre Fitment Due</span>
                        </div>
                        <ng-container *ngIf="dueForTyreChange.length; else noTyre">
                            <div *ngFor="let vehicle of dueForTyreChange" style="margin-bottom: 6px;" nz-row nzJustify="space-between">
                                <span nz-col nzSpan="8" style="font-weight: 500;">{{vehicle.make}} {{vehicle.model}} {{ vehicle.vreg }}:</span>
                                <span nz-col nzSpan="8" >Last: {{ vehicle.lastTyreChangeDt | date : 'dd MMM, yyyy' }}</span>
                                <span nz-col nzSpan="4" style="color: #cf1322; font-weight: bold;"> (Overdue)</span>
                            </div>
                        </ng-container>
                        <ng-template #noTyre>
                            <span style="color: #b7b7b7;">No vehicles due</span>
                        </ng-template>
                    </nz-card>
                </div>
            </div>
        </nz-collapse-panel>
    </nz-collapse>
    <div nz-col style="padding: 8px;">
        <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" [nzSize]="'large'" nzCentered>
            <nz-tab [nzTitle]="'Quotes' + ' (' + currentCustomer.quotes.length + ')'">
                <nz-table #QuoteTable [nzData]="currentCustomer.quotes" [nzSize]="'middle'" >
                    <thead>
                        <tr>
                        <th
                            nzShowSort
                            [nzSortFn]="sortByDate"
                        >Date</th>
                        <th
                            [nzFilters]="vehicleFilters"
                            [nzFilterFn]="vehicleFilterFn"
                        >Vehicle</th>
                        <th
                            [nzFilters]="sizeFilters"
                            [nzFilterFn]="sizeFilterFn"
                        >Tyre Size</th>
                        <th>Summary</th>
                        <th>Channel</th>
                        <th
                            [nzFilters]="salesmanFilterTerms"
                            [nzFilterFn]="salesmanFilterFn">Salesman</th>
                        <th
                            [nzFilters]="statusFilters"
                            [nzFilterFn]="statusFilterFn"
                        >Status</th>
                        <th [width]="'10%'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let deal of QuoteTable.data"  [ngClass]="{'quote-row-highlight': deal.stateId !== 3 && deal.stateType === 1}">                           
                            <td>{{ deal.dtCreated | date: 'dd MMM, yyyy' }}</td>
                            <td nz-popover nzPopoverTitle="Vehicle Summary" [nzPopoverContent]="vehicle" nzPopoverPlacement="topLeft">{{ deal.vreg }}</td>
                            <td>{{ deal.lineItems.length > 0 ? deal.lineItems[0].size : 'N/A' }}</td>
                            <td nz-popover [nzPopoverTitle]="'Quote ' + deal.ref" [nzPopoverContent]="deal.lineItems.length > 0 ? items : 'No data to display'">
                                <ng-container *ngFor="let item of getDealSummary(deal)" style="margin: 2px;">
                                    <span *ngIf="item.startsWith('sf'); else tyreBrand"><i  nz-icon nzType="{{item}}" nzTheme="outline" style="margin-right: 2px;" ></i></span>
                                    <ng-template #tyreBrand>
                                        <img class="brandImage-customer" style='margin-right: 1%;border-radius: 10px;' height='25' width='50' src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item}}">
                                    </ng-template>
                                </ng-container>
                                 <ng-template #items>
                                <div nz-col style="max-height: 300px; overflow-y: auto;">
                                    <table style="width: 100%; border-collapse: collapse;">

                                        <tbody>
                                            <tr *ngFor="let item of deal.lineItems" style="border-bottom: 1px solid #f0f0f0;">
                                                <td style="padding: 8px;">
                                                    {{ item.description }}
                                                    <span style="margin-left: 8px; color: #888; font-size: 13px; font-style: italic; font-weight: 500; border-radius: 4px; padding: 2px 6px;">
                                                        × {{ item.qty }}
                                                    </span>
                                                    <img *ngIf="item.stockTypeId==1" class="brandImage-customer" style="margin-left: 8px; border-radius: 6px;" height="25" width="50" src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item.brand}}">
                                                    <i *ngIf="item.stockTypeId !==1" nz-icon nzType="{{item.stockTypeImage}}" nzTheme="outline" style="margin-right: 2px;" ></i>
                                                </td>
                                                <td style="padding: 8px;">{{ item.size }}</td>
                                                <td style="padding: 8px; text-align: right;">
                                                    <span style="color: #1890ff; font-size: 15px; font-weight: 500;">{{ item.total | currency: 'R':'symbol' }}</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </ng-template>
                                                    <ng-template #vehicle>
                                    <span *ngIf="deal.vreg">{{ getVehicleSummary(deal.vreg) }}</span>
                                    <span *ngIf="!deal.vreg">No Vehicle</span>
                        </ng-template>
                            </td>
                            <td>
                                <span *ngIf="deal.ref.startsWith('S') || deal.ref.startsWith('N') ">Created  with <img src="../../assets/Images/s-logo-white.png" height='25' width='25'></span>
                                        <span *ngIf="deal.ref.startsWith('E')">Created Externally 
                                            <i nz-icon nzType="laptop" nzTheme="outline" class=" text"></i>        
                                </span>
                            </td>
                            <td>{{ deal.salesmanName }}</td>
                            <td>{{ deal.status }}</td>
                            <td nz-row nzJustify="space-evenly">
                                        <button nz-button nzType="primary" nz-tooltip="View" (click)="routeQuote(deal.id)">  <span nz-icon nzType="eye" nzTheme="outline"></span></button>
                                        <!-- <button nz-button nzType="primary" nz-tooltip="Quote Again"> <span nz-icon nzType="redo" nzTheme="outline"></span></button> -->
                                    </td>
                        </tr>
                    </tbody>
                </nz-table>
            </nz-tab>
            <nz-tab [nzTitle]="'Sales' +  ' (' + currentCustomer.sales.length + ')'">
                <nz-table #SalesTable [nzData]="currentCustomer.sales" [nzSize]="'middle'" >
                      <thead>
                        <tr>
                        <th
                            nzShowSort
                            [nzSortFn]="sortByDate"
                        >Date</th>
                        <th
                            [nzFilters]="vehicleFilters"
                            [nzFilterFn]="vehicleFilterFn"
                        >Vehicle</th>
                        <th
                            [nzFilters]="sizeFilters"
                            [nzFilterFn]="sizeFilterFn"
                        >Tyre Size</th>
                        <th>Summary</th>
                        <th>Channel</th>
                        <th
                            [nzFilters]="salesmanFilterTerms"
                            [nzFilterFn]="salesmanFilterFn">Salesman</th>
                        <th>Total</th>
                        <th [width]="'10%'"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let deal of SalesTable.data">
                            <td>{{ deal.dtCreated | date: 'dd MMM, yyyy' }}</td>
                            <td nz-popover nzPopoverTitle="Vehicle Summary" [nzPopoverContent]="vehicle" nzPopoverPlacement="topLeft">{{ deal.vreg }}</td>
                            <td>{{ deal.lineItems.length > 0 ? deal.lineItems[0].size : 'N/A' }}</td>
                            <td nz-popover [nzPopoverTitle]="'Sale ' + deal.ref" [nzPopoverContent]="deal.lineItems.length > 0 ? items : 'No data to display'">

                                <ng-container *ngFor="let item of getDealSummary(deal)" style="margin: 2px;">
                                    <span *ngIf="item.startsWith('sf'); else tyreBrand"><i  nz-icon nzType="{{item}}" nzTheme="outline" style="margin-right: 2px;" ></i></span>
                                    <ng-template #tyreBrand>
                                        <img class="brandImage-customer" style='margin-right: 1%;border-radius: 10px;' height='25' width='50'src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item}}">
                                    </ng-template>
                                </ng-container>

                            <ng-template #items>
                            <div nz-col style="max-height: 300px; overflow-y: auto;">
                                <table style="width: 100%; border-collapse: collapse;">
                                    <tbody>
                                        <tr *ngFor="let item of deal.lineItems" style="border-bottom: 1px solid #f0f0f0;">
                                            <td style="padding: 8px;">
                                                {{ item.description }}
                                                <span style="margin-left: 8px; color: #888; font-size: 13px; font-style: italic; font-weight: 500; border-radius: 4px; padding: 2px 6px;">
                                                    × {{ item.qty }}
                                                </span>
                                                <img *ngIf="item.stockTypeId==1" class="brandImage-customer" style="margin-left: 8px; border-radius: 6px;" height="25" width="50" src="https://sftptyres.blob.core.windows.net/brands-images/brands/{{item.brand}}">
                                                <i *ngIf="item.stockTypeId !==1" nz-icon nzType="{{item.stockTypeImage}}" nzTheme="outline" style="margin-right: 2px;" ></i>
                                            </td>
                                            <td style="padding: 8px;">{{ item.size }}</td>
                                            <td style="padding: 8px; text-align: right;">
                                                <span style="color: #1890ff; font-size: 15px; font-weight: 500;">{{ item.total | currency: 'R':'symbol' }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </ng-template>
                        <ng-template #vehicle>
                                    <span *ngIf="deal.vreg">{{ getVehicleSummary(deal.vreg) }}</span>
                                    <span *ngIf="!deal.vreg">No Vehicle</span>
                        </ng-template>
                            </td>
                            <td>
                                <span *ngIf="deal.ref.startsWith('S') || deal.ref.startsWith('N') ">Created  with <img src="../../assets/Images/s-logo-white.png" height='25' width='25'></span>
                                        <span *ngIf="deal.ref.startsWith('E')">Created Externally 
                                            <i nz-icon nzType="laptop" nzTheme="outline" class=" text"></i>        
                                </span>
                            </td>
                            <td>{{ deal.salesmanName }}</td>
                            <td>{{ deal.price | currency:'R':'symbol' }}</td>
                                    <td nz-row nzJustify="space-evenly">
                                        <button nz-button nzType="primary" nz-tooltip="View" (click)="routeSale(deal.id)">  <span nz-icon nzType="eye" nzTheme="outline"></span></button>
                                        <!-- <button nz-button nzType="primary" nz-tooltip="Quote Again"> <span nz-icon nzType="redo" nzTheme="outline"></span></button> -->
                                    </td>
                                </tr>
                                
                            </tbody>
                        </nz-table>
   

            </nz-tab>
            <nz-tab [nzTitle]="'Vehicles' + ' (' + currentCustomer.vehicles.length + ')'">
                <nz-table #VehicleTable [nzData]="currentCustomer.vehicles" [nzSize]="'middle'" >
                    <thead>
                        <tr>    
                            <th >Make</th>
                            <th >Model</th>
                            <th >Year</th>
                            <th >Vehicle Registration</th>
                            <th> Mileage</th>
                            <th >Size</th>
                            <th>Last Tyre Change</th>
                            <th>Last Wheel Balancing</th>
                            <th> Last Wheel Alignment</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let vehicle of VehicleTable.data">
                            <td>{{ vehicle.make }}</td>
                            <td>{{ vehicle.model }}</td>
                            <td>{{ vehicle.year }}</td>
                            <td>{{ vehicle.vreg }}</td>
                            <td>{{ vehicle.odometer != null ? (vehicle.odometer | number) + ' km' : 'N/A' }}</td>
                            <td>{{ vehicle.size }}</td>
                            <td [ngClass]="checkTyreDt(vehicle.lastTyreChangeDt) ? 'due' : ''"> {{ vehicle.lastTyreChangeDt | date: 'dd MMM, yyyy' }}</td>
                            <td [ngClass]="checkAlignmentBalancingDt(vehicle.lastBalancingDt) ? 'due' : ''">{{ vehicle.lastBalancingDt | date: 'dd MMM, yyyy' }}</td>
                            <td [ngClass]="checkAlignmentBalancingDt(vehicle.lastAlignmentDt) ? 'due' : ''">{{ vehicle.lastAlignmentDt | date: 'dd MMM, yyyy' }}</td>
                        </tr>
                    </tbody>
                </nz-table>

            </nz-tab>

        </nz-tabset>

    </div>
    
    </ng-container>
   <ng-template #loading>
        <div style="text-align: center; padding: 50px;">
            <nz-spin nzTip="Loading Customer Information..."></nz-spin>
        </div>
   </ng-template>
</nz-card>
